module.exports = __webpack_public_path__ + "img/KPI.167a7ffd.svg";